export default "__VITE_ASSET__d4107923__"